function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomMountFujiViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.13 12.418a1 1 0 01.884-.534h7.972a1 1 0 01.885.534l7.973 15.108-1.77.934-7.69-14.576h-6.767L4.925 28.46l-1.768-.934 7.973-15.108z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.662 17.035l2.29 1.865 2.404-1.843 2.206 1.787 1.297-1.238 1.38 1.447-2.569 2.452-2.348-1.902-2.408 1.846-2.24-1.824-2.26 1.878-2.642-2.438 1.357-1.47 1.354 1.25 2.18-1.81z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.259 5.78a2.795 2.795 0 110 5.592 2.795 2.795 0 010-5.591z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }));
}

export default SvgIconRoomMountFujiViewFilled;